export default "__VITE_ASSET__8ZaL1F2D__"